var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarehouseOperationsSelected = function SvgWarehouseOperationsSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 .25h-.055c-1.368 0-2.47 0-3.337.117-.9.12-1.658.38-2.26.981-.602.602-.86 1.36-.982 2.26C.25 4.475.25 5.578.25 6.945V13.055c0 1.367 0 2.47.116 3.337.121.9.38 1.658.982 2.26.602.602 1.36.86 2.26.982.867.116 1.97.116 3.337.116H13.055c1.367 0 2.47 0 3.337-.116.9-.122 1.658-.38 2.26-.982.601-.602.86-1.36.981-2.26.117-.867.117-1.97.117-3.337V6.945c0-1.367 0-2.47-.117-3.337-.12-.9-.38-1.658-.982-2.26-.601-.602-1.36-.86-2.26-.981C15.526.25 14.423.25 13.056.25H7ZM5.25 6A.75.75 0 0 1 6 5.25h6a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 6ZM6 9.25a.75.75 0 1 0 0 1.5h8a.75.75 0 0 0 0-1.5H6ZM5.25 14a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75Z",
    fill: "#050400"
  })));
};
export default SvgWarehouseOperationsSelected;